<template>
    <div class="flex flex-col text-center gap-4 items-center">
        <div>
            <vx-badge :borders="true" class="my-2">
                <font-awesome-icon widthAuto :icon="faCircleCheck"></font-awesome-icon>
                Message Queued
            </vx-badge>
            <h3 class="text-4xl font-extrabold text-slate-700">Success</h3>
            <p class="text-lg font-normal text-slate-600">Your message is queued for delivery.</p>
        </div>
        <div class="flex flex-col-reverse gap-2 sm:gap-4 mt-4 mb-4 w-full sm:flex-row sm:w-auto">
            <vx-button href="/messaging/campaigns" color="muted" size="lg"> View Campaigns </vx-button>
            <vx-button href="/messaging/quick-blast" color="primary" size="lg">
                New Quick Blast
                <font-awesome-icon widthAuto :icon="faArrowRight" class="text-base"></font-awesome-icon>
            </vx-button>
        </div>
    </div>
</template>

<script setup>
import { faArrowRight, faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxBadge, VxButton } from '@voxie/frontend-components';
</script>
